import { useEffect } from 'react'
import { useUIStore } from '@stores/useUIStore'
import { formatErrorMessage } from '@utils/error'

/**
 * Side-effect bridge that forwards `error` / `criticalError` state into the
 * toast queue. Renders nothing. `setMessages` / `setWarnings` already write
 * to `uiMessages` directly — no forwarding needed for those.
 */
const Alert = () => {
  const error = useUIStore(s => s.error)
  const criticalError = useUIStore(s => s.criticalError)
  const clearError = useUIStore(s => s.clearError)
  const addUIMessage = useUIStore(s => s.addUIMessage)

  useEffect(() => {
    const errorObj = error || criticalError
    if (!errorObj) {
      return
    }

    const message = formatErrorMessage(errorObj)
    if (message) {
      addUIMessage({ type: 'error', message })
    }
    clearError()
  }, [error, criticalError]) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

export default Alert
